import { Box, Grid } from '@mui/material'
import React from 'react'
import PerfectScrollbar from "react-perfect-scrollbar"
import AppCard from './AppCard';
import { FetchAllResources } from 'api/resources';
import Cookies from 'js-cookie';
import { navigateToDomain } from 'utilities/index';

const Resources = ({inProfileView = false}) => {

    const cookieStartupId = Cookies.get("X-ST-ID");
    const { data: resources, isLoading } = FetchAllResources(cookieStartupId);

    return (
        <PerfectScrollbar
            style={{ height: inProfileView ? "calc(-12rem + 100dvh)" : "calc(-10rem + 100dvh)" }}>
            <Box sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(min(22.4375rem, 100%), 1fr))',
                gap: { xs: "2rem", sm: "3rem", md: "4rem" },
                padding: { xs: "0 1rem 1rem 1rem", md: "0 1rem 2rem 2rem" },
                justifyItems: { xs: 'center', md: "start" }
            }}>
                {isLoading ? <></> : resources?.map((resource, index) => {
                    return <AppCard
                        key={index}
                        card={{...resource, image: resource?.thumbnail_image, button_text: "View Resource"}}
                        onClick={() => {
                            // Navigate to resource detail page
                            resource?.slug && window.open(navigateToDomain("main", "resources/" + resource?.slug))
                        }}
                        cardSx={{...resource?.cardStyle}}
                    />
                })}
            </Box>

        </PerfectScrollbar>
    )
}

export default Resources
